function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "World Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.7,30.7l-2.2-2L39,27.5l-3.3-1.6l-5.9,1.2l-5.2,8.7l4.1,5.2l0.2,5.6l0.8,8.8L41.9,53l3.6-6l4.3-3.4l3.8-8.6 L46.7,30.7z M46.5,41l-4.1,3.3l-3,5.1l-6.1,1.2l-0.4-4.2l-0.3-6.9l-3.2-4l2.9-4.8l2.8-0.5l2.5,1.3l4.9,1l1.5,1.4l4.3,2.7L46.5,41z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.5,0C14.1,0,0,14.1,0,31.5C0,48.9,14.1,63,31.5,63S63,48.9,63,31.5C63,14.1,48.9,0,31.5,0z M51.3,12.4 l-5.7,1.9l-4.9,3.2l-2.8-1.9l-0.7-6.2l-3.9,0.1l-0.4-3.1L30.4,5l0.3-1c0.3,0,0.5,0,0.8,0C39.3,4,46.3,7.2,51.3,12.4z M4,31.5 c0-8.4,3.8-15.9,9.8-21l2.5,3.5l1.9,2.1l0,2.6l0.6,4.2l-2.5,1.3l-4.1,2.7l-4.6,4.7l3.1,7.7l2.7,1.8l1.1,6.7L13,48.6l-1.4,1.9 C6.9,45.6,4,38.9,4,31.5z M31.5,59c-6.4,0-12.2-2.2-16.9-5.8l1.1-1.5L19,50l-1.9-11.2L14,36.6l-1.7-4.2l2.3-2.4l3.6-2.4l4.9-2.5 l-1-6.6l0-4l-2.7-3L17,8.2c2.8-1.8,6-3,9.3-3.7l-0.7,2.3l3.5,2.1l0.6,4.8l3.8-0.1l0.5,4.4l6.5,4.4l6.7-4.4l6.7-2.3 c3.1,4.5,5,9.9,5,15.8C59,46.7,46.7,59,31.5,59z"
});

var SvgWorld = function SvgWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 63 63",
    fill: "#00dacc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world.64099cdf.svg";
export { ForwardRef as ReactComponent };